import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { WdxToastService } from '@wdx/shared/components/wdx-toast';
import {
    Severity,
    TRANSLATION_TOAST_MESSAGE_FILE_PARSED_SUCCESSFULLY,
    TranslationsService,
} from '@wdx/shared/utils';
import { of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { ExtractPdfService } from '../extract-pdf/extract-pdf.service';
import * as investorRiskProfileActions from './investor-risk-profile.actions';

@Injectable()
export class InvestorRiskProfileEffects {
    private actions$ = inject(Actions);
    private extractPdfService = inject(ExtractPdfService);
    private toastService = inject(WdxToastService);
    private translationsService = inject(TranslationsService);

    extractPdfFile$ = createEffect(() =>
        this.actions$.pipe(
            ofType(investorRiskProfileActions.extractPdfFile),
            mergeMap((action) =>
                this.extractPdfService
                    .extractPdf(action.file, action.entityId, action.formName)
                    .pipe(
                        map(() =>
                            investorRiskProfileActions.extractPdfFileSuccess()
                        ),
                        catchError((error) =>
                            of(
                                investorRiskProfileActions.extractPdfFileError({
                                    error,
                                })
                            )
                        )
                    )
            )
        )
    );

    extractPdfFileSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(investorRiskProfileActions.extractPdfFileSuccess),
                tap(() => {
                    this.toastService.show({
                        body: [
                            this.translationsService.getTranslationByKey(
                                TRANSLATION_TOAST_MESSAGE_FILE_PARSED_SUCCESSFULLY
                            ),
                        ],
                        severity: Severity.Success,
                    });
                })
            ),
        { dispatch: false }
    );

    extractPdfFileError$ = createEffect(() =>
        this.actions$.pipe(
            ofType(investorRiskProfileActions.extractPdfFileError),
            tap((error) => {
                this.toastService.show({
                    body: [error.error.message],
                    severity: Severity.Danger,
                });
            })
        )
    );
}
